// @ts-nocheck
/* eslint-disable */
import { reducerWrapper, strToTitleCase } from '../support/utils';
import {
  RETRIEVE_DISCO_ADS_CAMPAIGNS,
  RETRIEVE_SINGLE_CAMPAIGN,
  RETRIEVE_DISCO_ADS_AD_GROUPS,
  RETRIEVE_SINGLE_AD_GROUP,
  RETRIEVE_DISCO_ADS_CREATIVES,
  UPDATE_DISCO_ADS_CAMPAIGN,
  UPDATE_DISCO_ADS_AD_GROUP,
  UPDATE_DISCO_ADS_CREATIVE,
  UPDATE_CURRENT_CAMPAIGN,
  UPDATE_CURRENT_AD_GROUP,
  SAVE_DISCO_ADS_CREATOR_STEP,
  CREATE_CAMPAIGN_BATCH,
  CREATE_AD_GROUP_BATCH,
  CLEAR_DISCO_ADS_CREATOR_DATA,
  CLEAR_DISCO_ADS_CREATOR_STEP,
  UNSET_CURRENT_AD_OBJECT,
  UPLOAD_DISCO_ADS_CREATIVE,
  GENERATE_CREATIVE,
  FETCH_GEO_TARGETING_SHAPES,
  CLEAR_CREATIVE_IMAGE_URL,
} from '../actions/DiscoAdsActions';

import { DA_CAMPAIGN_SETUP, DA_AD_GROUP_SETUP } from '../screens/ScreenDiscoAds/discoAdsConstants';

const INIT_STATE = {
  error: null,
  campaigns: {},
  ad_groups: {},
  creatives: {},
  creator: {},
  geoTargetingShapes: [],
  currentCampaign: {},
  currentAdGroup: {},
};

export const handleUpdate = ({ freshProps, stateProperty }) => {
  if (!freshProps || !stateProperty) {
    return [];
  }
  const { data } = stateProperty;
  const { id: targetID } = freshProps;

  const updateIndex = data.findIndex((obj) => obj.id === targetID);
  if (updateIndex === -1) {
    return data;
  }
  const updatedDataObject = Object.assign({}, data[updateIndex], freshProps);
  return [...data.slice(0, updateIndex), updatedDataObject, ...data.slice(updateIndex + 1)];
};

function Handler(state, action) {
  const { campaigns, ad_groups, creatives, currentCampaign, currentAdGroup } = state;

  switch (action.type) {
    case RETRIEVE_DISCO_ADS_CAMPAIGNS.response:
      return {
        ...state,
        loading: false,
        campaigns: action.data,
      };

    case RETRIEVE_SINGLE_CAMPAIGN.response:
      return {
        ...state,
        currentCampaign: action.data,
      };
    case UPDATE_DISCO_ADS_CAMPAIGN.response:
      const updatedCampaignProps = action.data;
      const updatedCampaignsData = handleUpdate({
        freshProps: updatedCampaignProps,
        stateProperty: campaigns,
      });
      return {
        ...state,
        loading: false,
        campaigns: Object.assign({}, campaigns, { data: updatedCampaignsData }),
      };

    case RETRIEVE_DISCO_ADS_AD_GROUPS.response:
      return {
        ...state,
        loading: false,
        ad_groups: action.data,
      };

    case RETRIEVE_SINGLE_AD_GROUP.response:
      return {
        ...state,
        currentAdGroup: action.data,
      };

    case UPDATE_DISCO_ADS_AD_GROUP.response:
      const updatedAdGroupProps = action.data;
      const updatedAdGroupsData = handleUpdate({
        freshProps: updatedAdGroupProps,
        stateProperty: ad_groups,
      });
      return {
        ...state,
        loading: false,
        ad_groups: Object.assign({}, ad_groups, { data: updatedAdGroupsData }),
      };

    case RETRIEVE_DISCO_ADS_CREATIVES.response:
    case GENERATE_CREATIVE.response:
      return {
        ...state,
        loading: false,
        creatives: action.data,
      };

    case UPDATE_DISCO_ADS_CREATIVE.response:
      const updatedCreativeProps = action.data;
      const updatedCreativesData = handleUpdate({
        freshProps: updatedCreativeProps,
        stateProperty: creatives,
      });
      return {
        ...state,
        loading: false,
        creatives: Object.assign({}, creatives, { data: updatedCreativesData }),
      };

    case UNSET_CURRENT_AD_OBJECT:
      const { keys: adObjectTypesToClear } = action;
      const newState = { ...state };
      adObjectTypesToClear.forEach((type) => {
        const key = `current${strToTitleCase(type)}`;
        newState[key] = {};
      });
      return newState;

    case UPDATE_CURRENT_CAMPAIGN.response:
      const updatedCurrentCampaign = {
        ...currentCampaign,
        ...action.data,
      };
      return {
        ...state,
        currentCampaign: updatedCurrentCampaign,
        loading: false,
      };

    case UPDATE_CURRENT_AD_GROUP.response:
      const updatedCurrentAdGroup = {
        ...currentAdGroup,
        ...action.data,
      };
      return {
        ...state,
        currentAdGroup: updatedCurrentAdGroup,
        loading: false,
      };

    case SAVE_DISCO_ADS_CREATOR_STEP:
      const { stepKey, payload } = action;
      const { creator } = state;
      let newCreator = {
        ...creator,
        [stepKey]: payload,
      };
      return {
        ...state,
        loading: false,
        creator: newCreator,
      };

    case FETCH_GEO_TARGETING_SHAPES.response:
      return {
        ...state,
        loading: false,
        geoTargetingShapes: action.data,
      };

    case CREATE_CAMPAIGN_BATCH.response:
      const { id } = action.data;
      const { campaignSetup } = state.creator;
      const campaignSetupWithNewCampaignId = Object.assign({}, campaignSetup, {
        id,
      });
      newCreator = {
        ...state.creator,
        [DA_CAMPAIGN_SETUP]: campaignSetupWithNewCampaignId,
      };
      return {
        ...state,
        creator: newCreator,
      };

    case CREATE_AD_GROUP_BATCH.response: {
      const { id } = action.data;
      const { adGroupSetup } = state.creator;
      const adGroupSetupWithNewAdGroupId = Object.assign({}, adGroupSetup, {
        id,
      });
      newCreator = {
        ...state.creator,
        [DA_AD_GROUP_SETUP]: adGroupSetupWithNewAdGroupId,
      };
      return {
        ...state,
        creator: newCreator,
      };
    }

    case CLEAR_DISCO_ADS_CREATOR_DATA:
      return {
        ...state,
        creator: {},
        geoTargetingShapes: [],
      };

    case CLEAR_DISCO_ADS_CREATOR_STEP:
      return {
        ...state,
        creator: {
          ...state.creator,
          [action.stepKey]: undefined,
        },
      };

    case UPLOAD_DISCO_ADS_CREATIVE.response:
      const { data: imageUrl } = action;
      newCreator = {
        ...state.creator,
        creativeSetup: { imageUrl },
      };
      return {
        ...state,
        loading: false,
        creator: newCreator,
      };

    case CLEAR_CREATIVE_IMAGE_URL:
      newCreator = {
        ...state.creator,
        creativeSetup: Object.assign({}, state.creator.creativeSetup || {}, {
          imageUrl: null,
        }),
      };
      return {
        ...state,
        loading: false,
        creator: newCreator,
      };

    default:
      return state;
  }
}

const DiscoAds = reducerWrapper(INIT_STATE, Handler, {
  request: [
    RETRIEVE_DISCO_ADS_CAMPAIGNS,
    RETRIEVE_SINGLE_CAMPAIGN,
    RETRIEVE_DISCO_ADS_AD_GROUPS,
    RETRIEVE_SINGLE_AD_GROUP,
    RETRIEVE_DISCO_ADS_CREATIVES,
    UPDATE_DISCO_ADS_CAMPAIGN,
    UPDATE_DISCO_ADS_AD_GROUP,
    UPDATE_DISCO_ADS_CREATIVE,
    SAVE_DISCO_ADS_CREATOR_STEP,
    CREATE_CAMPAIGN_BATCH,
    CREATE_AD_GROUP_BATCH,
    CLEAR_DISCO_ADS_CREATOR_DATA,
    CLEAR_DISCO_ADS_CREATOR_STEP,
    UPLOAD_DISCO_ADS_CREATIVE,
    CLEAR_CREATIVE_IMAGE_URL,
    UNSET_CURRENT_AD_OBJECT,
    UPDATE_CURRENT_CAMPAIGN,
    UPDATE_CURRENT_AD_GROUP,
    GENERATE_CREATIVE,
    FETCH_GEO_TARGETING_SHAPES,
  ],
  error: [
    RETRIEVE_DISCO_ADS_CAMPAIGNS,
    RETRIEVE_SINGLE_CAMPAIGN,
    RETRIEVE_DISCO_ADS_AD_GROUPS,
    RETRIEVE_SINGLE_AD_GROUP,
    RETRIEVE_DISCO_ADS_CREATIVES,
    UPDATE_DISCO_ADS_CAMPAIGN,
    UPDATE_DISCO_ADS_AD_GROUP,
    UPDATE_DISCO_ADS_CREATIVE,
    SAVE_DISCO_ADS_CREATOR_STEP,
    CREATE_CAMPAIGN_BATCH,
    CREATE_AD_GROUP_BATCH,
    CLEAR_DISCO_ADS_CREATOR_DATA,
    CLEAR_DISCO_ADS_CREATOR_STEP,
    UPLOAD_DISCO_ADS_CREATIVE,
    UNSET_CURRENT_AD_OBJECT,
    UPDATE_CURRENT_CAMPAIGN,
    UPDATE_CURRENT_AD_GROUP,
    GENERATE_CREATIVE,
    FETCH_GEO_TARGETING_SHAPES,
  ],
});

export default DiscoAds;
